import React from 'react';
import Wrapper from '../../components/Wrapper';
import AccessDeniedIcon from '../../SVG/AccessDeniedIcon';
import { useTranslation } from '../../hooks/useTranslation';
import './styles.scss';

const AccessDenied = () => {
  const { t } = useTranslation();
  
  return (
    <Wrapper>
      <div className='container'>
        <AccessDeniedIcon />
        <h1>{t('accessDenied.title')}</h1>
        <p>{t('accessDenied.message')}</p>
      </div>
    </Wrapper>
  );
};

export default AccessDenied;
